import styled from 'styled-components'

import Filter from 'components/Filter'
import { Container, SearchInput } from 'components/Filter/Filter.styles'
import { Input } from '@sketch/components'

export const SearchField = styled(Filter)<{
  expand: boolean
}>`
  ${Container}, ${SearchInput} {
    height: 32px;
  }

  ${Input} {
    position: relative;
    width: 100%;
    background: none;
    max-width: ${({ expand }) => (expand ? '100%' : '196px')};
    border-color: ${({ theme }) => theme.colors.border.A};
  }
`
